import { useEffect, useState } from 'react';
import { Typography } from '@mui/material'
import { authenticateToDirectoryOrRedirect } from '@promethee/authentication';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { deserializeErrors} from 'apollo-client'
import Loading from 'components/global/Loading';
import useActions from '../use-actions'

const Redirect = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate()
  const { sso } = useActions()

  useEffect(() => {
    sso()
      .then(() => navigate('/'))
      .catch(e => setError(deserializeErrors(e)));
  }, []);

  return error ? <Typography variant={'caption'}>{error}</Typography> : <Loading />
};

const DirectorySSO = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      await authenticateToDirectoryOrRedirect({
        authentUrl: process.env.REACT_APP_AUTH_URL,
        env: process.env.NODE_ENV,
        appName: process.env.REACT_APP_AUTH_APP_NAME,
        jwt: process.env.REACT_APP_AUTH_JWT,
      });
      setReady(true);
    })();
  }, []);
  return (
    <Box
      width={'100%'}
      height={'100vh'}
      display={'flex'}
      alignItems={'center'}
      justifyContent="center"
    >
      {ready ? <Redirect /> : <Loading />}
    </Box>
  );
};

export default DirectorySSO;
